import apiClient from './client';

export const faqApi = {
  getAll: (params) => apiClient.get('/api/faq', { params }),

  getById: (id) => apiClient.get(`/api/faq/${id}`),

  create: (data) => apiClient.post('/api/faq', data),

  update: (id, data) => apiClient.put(`/api/faq/${id}`, data),

  delete: (id) => apiClient.delete(`/api/faq/${id}`),

  reorder: (data) => apiClient.post('/api/faq/reorder', data),

  getCategories: () => apiClient.get('/api/faq/categories'),

  createCategory: (data) => apiClient.post('/api/faq/categories', data),

  updateCategory: (id, data) => apiClient.put(`/api/faq/categories/${id}`, data),

  deleteCategory: (id) => apiClient.delete(`/api/faq/categories/${id}`),

  search: (query) => apiClient.get('/api/faq/search', { params: { query } }),

  bulkDelete: (ids) => apiClient.post('/api/faq/bulk-delete', { ids }),

  export: (format) => apiClient.get('/api/faq/export', {
    params: format ? { format } : undefined,
    responseType: 'blob',
  }),

  import: (formData) => apiClient.post('/api/faq/import', formData, {
  }),

  toggleStatus: (id) => apiClient.put(`/api/faq/${id}/toggle`),
};

export default faqApi;
